import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GlobalService } from '../global.service';
import { BehaviorService } from './behavior.service';
import { EventsService } from './events.service';
import { Router } from '@angular/router';
import { AccountService } from 'projects/authentication/_services/account.service';
import { tap } from 'rxjs/operators';
import { SubscriptionService } from 'projects/authentication/_services/subscription.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { LangService } from './lang.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public currentUser = new BehaviorSubject<any>(localStorage.u ? JSON.parse(localStorage.u) : {});

  private callProcessing: any = {};

  constructor(
    private router: Router,
    private event: EventsService,
    private global: GlobalService,
    private beh: BehaviorService,
    private accountSvc: AccountService,
    private subsSvc: SubscriptionService,
    private socialAuthSvc: SocialAuthService,
    private langSvc: LangService
  ) { }

  public doLogin(trigger: boolean = true, navTo: string[] = null, social: boolean = false) {
    let user = JSON.parse(localStorage.u || '{}');
    social ? user.s = true : delete user.s;
    localStorage.u = JSON.stringify(user);

    this.loadUserAccountInfo(true, navTo).toPromise();

    if (trigger) {
      this.event.eventStart({ eventType: 'LOGIN_SUCCESS', eventCategory: 'SUCCESS' });
    }
  }

  public doLogOut(reload: boolean = true) {
    this.event.eventStart({ eventType: 'LOGOUT_SUCCESS', eventCategory: 'SUCCESS' });
    let user = JSON.parse(localStorage.u || '{}');
    let userSession = JSON.parse(sessionStorage.u || '{}');

    const clearStorage = () => {
      user = JSON.parse(localStorage.u || '{}');
      userSession = JSON.parse(sessionStorage.u || '{}');

      delete user.j;
      delete user.s;
      delete user.p;
      delete user.tid;
      delete userSession.at;
      delete userSession.tt;
      delete localStorage.w;
      localStorage.u = JSON.stringify(user);
      sessionStorage.u = JSON.stringify(userSession);

      reload && (location.href = `${location.protocol}//${location.host}`);
    }

    !!user.s && this.socialAuthSvc.signOut().then(out => {
      console.debug(out);
      clearStorage();
    }).catch(err => { console.debug(err) });

    !user.s && clearStorage();
  }

  public loadUserAccountInfo(forceReload: boolean = false, navigateTo: string[] = null) {
    if (!!this.beh.AccountCallResp_.value && !forceReload) {
      !!navigateTo && this.router.navigate(navigateTo, { queryParams: this.global.getQueryParams(), queryParamsHandling: 'merge' });
      return this.beh.AccountCallResp_;
    } else {
      return this.accountSvc.getAccount().pipe(tap(user => {
        if (user?.responseCode == 'SUCCESS') {
          this.beh.AccountCallResp_.next(user);
          this.beh.UserAccount.next(user.account);

          !this.callProcessing.wallet && this.loadUserWallet();
          !this.callProcessing.subscription && this.loadUserSubscription();
          !!navigateTo && this.router.navigate(navigateTo, { queryParams: this.global.getQueryParams(), queryParamsHandling: 'merge' });

          /* navigateTo validation */
          if (!!user.account.profileProps?.ACCOUNT_LANGUAGE && JSON.parse(localStorage.u || '{}').l?.replace('-', '_') != user.account.profileProps?.ACCOUNT_LANGUAGE) {
            this.langSvc.changeLang(user.account.profileProps.ACCOUNT_LANGUAGE);
          }

          return user;
        } else {
          return null;
        }
      }, noUser => { noUser.error == 'header required! jwt' && this.router.navigate([''], { queryParamsHandling: 'merge' }) }));
    }
  }

  public loadUserWallet() {
    this.callProcessing.wallet = true;
    this.accountSvc.getWallet().subscribe(wallet => {
      this.beh.UserWallet.next(wallet?.responseCode == 'SUCCESS' ? wallet : {});
      this.callProcessing.wallet = false;
    }, () => {
      this.beh.UserWallet.next({});
      this.callProcessing.wallet = false;
    });
  }

  public loadUserSubscription() {
    this.callProcessing.subscription = true;
    this.subsSvc.checkSubscription({ status: ['ACTIVE'] }).subscribe(sub => {
      this.beh.UserSubscription.next(sub || null);
      this.callProcessing.subscription = false;

      let userSession = JSON.parse(sessionStorage.u || '{}');

      if (sub?.partnerResponse?.productActivation[0]?.subStatusName == 'SUSPENDED' && !userSession.sus) {
        this.beh.popup.next({ pop: sub.partnerResponse.productActivation[0].productInfo?.paymentMethod == 'STRIPE' ? 'card-payment-error' : 'operator-payment-error' });
        userSession.sus = true;
        sessionStorage.u = JSON.stringify(userSession);
      }
    }, () => {
      this.beh.UserSubscription.next(null);
      this.callProcessing.subscription = false;
    });
  }

}